<template>
  <div class="">
    <div class="container">
      <div class="row">
        <div class="col-12 justify-content-center top-bar-logo-vas top-bar-logo-wrapper top-bar-logo-wrapper-lp">
          <router-link to="/" class="top-bar-logo gtm_home router-link-active">
            <img
              :src="require('@/assets/portales/logo-white-2.png')"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";


export default {
  directives: {
    "b-modal": bModalDirective,
  },
};
</script>

